import { useQuery } from '@tanstack/react-query';
import { pesquisasService } from '../api/pesquisas';
import { marcaGestaoApi } from '../api/marcaGestao';

const CACHE_TIME = 10 * 60 * 1000; // 10 min

export function useEmpresas() {
  return useQuery({
    queryKey: ['pesquisas', 'empresas'],
    queryFn: () => pesquisasService.getEmpresas(),
    staleTime: CACHE_TIME,
  });
}

export function useAlmoxarifados() {
  return useQuery({
    queryKey: ['pesquisas', 'almoxarifados'],
    queryFn: () => pesquisasService.getAlmoxarifados(),
    staleTime: CACHE_TIME,
  });
}

export function useMarcas() {
  return useQuery({
    queryKey: ['pesquisas', 'marcas'],
    queryFn: () => pesquisasService.getMarcas(),
    staleTime: CACHE_TIME,
  });
}

export function useMarcasGestao(incluirDesativadas = true) {
  return useQuery({
    queryKey: ['marcas-gestao', incluirDesativadas],
    queryFn: () => marcaGestaoApi.listar(incluirDesativadas),
    staleTime: CACHE_TIME,
  });
}

export function useGrupos() {
  return useQuery({
    queryKey: ['pesquisas', 'grupos'],
    queryFn: () => pesquisasService.getGrupos(),
    staleTime: CACHE_TIME,
  });
}

export function useFornecedores() {
  return useQuery({
    queryKey: ['pesquisas', 'fornecedores'],
    queryFn: () => pesquisasService.getFornecedores(),
    staleTime: CACHE_TIME,
  });
}

/**
 * Autocomplete de produtos (busca incremental). Backend exige mínimo 2
 * caracteres e limita a 20 resultados. Cache curto (30s) — usuário pode
 * digitar/apagar várias vezes na mesma sessão de busca.
 *
 * Usado pelo dialog "Adicionar produto" em /compras/analise.
 */
export function useProdutosAutocomplete(query: string, enabled = true) {
  const q = (query ?? '').trim();
  return useQuery({
    queryKey: ['pesquisas', 'produtos-autocomplete', q],
    queryFn: () => pesquisasService.getProdutosAutocomplete(q),
    enabled: enabled && q.length >= 2,
    staleTime: 30 * 1000,
  });
}
